module.exports = __webpack_public_path__ + "static/media/chevron-right.3b1b423b.svg";